import { enumParser } from '#validation/common/parsers';
import { DomainSsoEnforcement } from '../constants';
export const domainSsoEnforcementParser = enumParser(DomainSsoEnforcement);
